module.exports = __webpack_public_path__ + "img/VZ.91b22b52.png";